// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as MomentTZ$LiveRoom from "../bindings/MomentTZ.bs.js";
import * as ClockStore$LiveRoom from "../stores/ClockStore.bs.js";
import * as Utils_Shared$LiveRoom from "./Utils_Shared.bs.js";

function getSessionName(sessionTitle, sessionId, t2) {
  if (sessionTitle !== undefined) {
    return sessionTitle;
  } else {
    return Curry._2(t2, "Common_sessionNumber", {
                sessionNumber: sessionId + 1 | 0
              });
  }
}

function getSessionDate(json) {
  return Belt_Option.getWithDefault(Js_json.decodeString(json), "");
}

function getNextSessionTimeV2(sessionDate, t) {
  var countdown = Utils_Shared$LiveRoom.Timer.calculateDiff(ClockStore$LiveRoom.getServerTime(undefined), Utils_Shared$LiveRoom.Timer.stringToEpochTime(Belt_Option.getWithDefault(Js_json.decodeString(sessionDate), "")));
  if (typeof countdown === "number") {
    return [
            Curry._1(t, "Common_startShortly"),
            "TimeReached"
          ];
  }
  switch (countdown.TAG | 0) {
    case /* LessThen24hours */0 :
        return [
                MomentTZ$LiveRoom.momentFormat(Belt_Option.getWithDefault(Js_json.decodeString(sessionDate), ""), "HH:mm zz "),
                "LessThen24hours"
              ];
    case /* DaysUntil */1 :
        return [
                MomentTZ$LiveRoom.momentFormat(Belt_Option.getWithDefault(Js_json.decodeString(sessionDate), ""), "MMMM D, HH:mm zz "),
                "DaysUntil"
              ];
    case /* TimeUntilReached */2 :
        return [
                "",
                "LotCloseTime"
              ];
    
  }
}

export {
  getSessionName ,
  getSessionDate ,
  getNextSessionTimeV2 ,
}
/* MomentTZ-LiveRoom Not a pure module */
